/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .line {
    fill: #1b1f2a;
  }
  .light {
    fill: ${theme.color.white};
  }
  .yellow {
    fill: ${theme.color.yellow};
  }
`

export default class LightBulbIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10.223" height="19.055" viewBox="0 0 10.223 19.055" css={Color} className="light-bulb-icon">
        <g id="그룹_7267" data-name="그룹 7267" transform="translate(-33.972 -636.659)">
          <path id="패스_2" data-name="패스 2"
                d="M3407.378,1219.812h0a.4.4,0,0,1-.4-.4l0-1.637a.4.4,0,0,1,.4-.4h0a.4.4,0,0,1,.4.4l0,1.637A.4.4,0,0,1,3407.378,1219.812Z"
                transform="translate(-3368.297 -580.708)" fill="#1b1f2a" className="line"/>
          <path id="패스_3" data-name="패스 3"
                d="M3418.256,1222.376a.4.4,0,0,1-.32-.65l1.046-1.364a.4.4,0,1,1,.641.492l-1.047,1.364A.4.4,0,0,1,3418.256,1222.376Z"
                transform="translate(-3375.514 -582.59)" fill="#1b1f2a" className="line"/>
          <path id="패스_4" data-name="패스 4"
                d="M3394.451,1222.376a.4.4,0,0,1-.321-.158l-1.046-1.364a.4.4,0,1,1,.641-.492l1.047,1.364a.4.4,0,0,1-.32.65Z"
                transform="translate(-3359.027 -582.59)" fill="#1b1f2a" className="line"/>
          <path id="패스_5" data-name="패스 5" d="M3406.715,1268.27a1.515,1.515,0,0,1-3.03,0"
                transform="translate(-3366.116 -614.472)" fill="#fff" className="light"/>
          <path id="패스_6" data-name="패스 6"
                d="M3404.4,1269.391a1.922,1.922,0,0,1-1.92-1.919.4.4,0,0,1,.808,0,1.111,1.111,0,0,0,2.222,0,.4.4,0,0,1,.4-.4h0a.4.4,0,0,1,.4.4A1.922,1.922,0,0,1,3404.4,1269.391Z"
                transform="translate(-3365.319 -613.677)" fill="#1b1f2a" className="line"/>
          <rect id="사각형_2" data-name="사각형 2" width="4.253" height="2.655" transform="translate(36.959 651.142)"
                fill="#294b72"/>
          <path id="패스_7" data-name="패스 7"
                d="M3405.33,1262.65h-4.253a.4.4,0,0,1-.4-.4v-2.655a.4.4,0,0,1,.4-.4h4.253a.4.4,0,0,1,.4.4v2.655A.4.4,0,0,1,3405.33,1262.65Zm-3.849-.808h3.445v-1.846h-3.445Z"
                transform="translate(-3364.117 -608.449)" fill="#1b1f2a" className="line"/>
          <path id="패스_8" data-name="패스 8"
                d="M3401.047,1240.206a9.429,9.429,0,0,1,.472-1.349c.593-1.01,2.1-2.356,2.1-4.191h.009a4.7,4.7,0,0,0-9.408,0h0c0,1.832,1.5,3.18,2.1,4.191a9.688,9.688,0,0,1,.471,1.349h4.253"
                transform="translate(-3359.835 -589.062)" fill="#fc0" className="yellow"/>
          <path id="패스_9" data-name="패스 9"
                d="M3400.252,1239.814a.4.4,0,0,1-.056,0h-4.2a.4.4,0,0,1-.39-.3,9.368,9.368,0,0,0-.442-1.27c-.142-.238-.348-.51-.566-.8a6,6,0,0,1-1.576-3.576,5.107,5.107,0,0,1,5.106-5.1h0a5.124,5.124,0,0,1,5.107,5.108.4.4,0,0,1-.01.086,6.1,6.1,0,0,1-1.575,3.491c-.218.288-.424.561-.566.8a9.178,9.178,0,0,0-.442,1.269A.4.4,0,0,1,3400.252,1239.814ZM3396.3,1239h3.651a9.881,9.881,0,0,1,.4-1.1.463.463,0,0,1,.022-.043,9.84,9.84,0,0,1,.63-.9,5.293,5.293,0,0,0,1.413-3.09.376.376,0,0,1,.008-.078,4.315,4.315,0,0,0-4.3-4.223h0a4.3,4.3,0,0,0-4.3,4.3,5.3,5.3,0,0,0,1.412,3.09,9.92,9.92,0,0,1,.631.9.337.337,0,0,1,.022.043A9.935,9.935,0,0,1,3396.3,1239Z"
                transform="translate(-3359.04 -588.266)" fill="#1b1f2a" className="line"/>
          <path id="패스_10" data-name="패스 10"
                d="M3399.456,1238.35a.4.4,0,0,1-.4-.38,2.9,2.9,0,0,1,2.688-3.059.4.4,0,0,1,.056.806,2.091,2.091,0,0,0-1.936,2.2.4.4,0,0,1-.379.427Z"
                transform="translate(-3363.039 -592.345)" fill="#fff" className="light"/>
          <path id="패스_11" data-name="패스 11" d="M3406.2,1250.56h-.591a.4.4,0,0,1,0-.808h.591a.4.4,0,1,1,0,.808Z"
                transform="translate(-3367.125 -602.19)" fill="#1b1f2a" className="line"/>
          <path id="패스_12" data-name="패스 12" d="M3407.74,1250.557h-.356a.4.4,0,1,1,0-.808h.356a.4.4,0,0,1,0,.808Z"
                transform="translate(-3368.301 -602.188)" fill="#1b1f2a" className="line"/>
          <path id="패스_13" data-name="패스 13"
                d="M3402.9,1248.357a.432.432,0,0,1-.061,0h-.86a.911.911,0,0,1-.866-.915c0-.029,0-.064,0-.1h0c0-.005,0-.01,0-.016a1.087,1.087,0,0,1,1.833-.582,1.582,1.582,0,0,1,.351,1.082v.127A.4.4,0,0,1,3402.9,1248.357Zm-.978-.938c0,.081.037.122.087.126h.464a.513.513,0,0,0-.107-.246.214.214,0,0,0-.173-.06l-.043,0A.205.205,0,0,0,3401.922,1247.419Z"
                transform="translate(-3364.409 -599.985)" fill="#1b1f2a" className="line"/>
          <path id="패스_14" data-name="패스 14"
                d="M3405.629,1253.679a.4.4,0,0,1-.4-.4v-3.113a.4.4,0,0,1,.808,0v3.113A.4.4,0,0,1,3405.629,1253.679Z"
                transform="translate(-3367.137 -602.194)" fill="#1b1f2a" className="line"/>
          <path id="패스_15" data-name="패스 15"
                d="M3409.142,1253.679a.4.4,0,0,1-.4-.4v-3.113a.4.4,0,0,1,.808,0v3.113A.4.4,0,0,1,3409.142,1253.679Z"
                transform="translate(-3369.467 -602.194)" fill="#1b1f2a" className="line"/>
          <path id="패스_16" data-name="패스 16"
                d="M3409.14,1248.371a.4.4,0,0,1-.387-.287.418.418,0,0,1-.019-.122c0-.011,0-.022,0-.032v-.111a1.572,1.572,0,0,1,.352-1.061,1.016,1.016,0,0,1,.741-.312.533.533,0,0,0,.083,0,1.016,1.016,0,0,1,1.016,1.015.907.907,0,0,1-.835.908h-.892A.519.519,0,0,1,3409.14,1248.371Zm.427-.812h.493a.1.1,0,0,0,.059-.1.209.209,0,0,0-.208-.211h0l-.063,0a.21.21,0,0,0-.173.06A.512.512,0,0,0,3409.566,1247.559Z"
                transform="translate(-3369.465 -599.995)" fill="#1b1f2a" className="line"/>
          <path id="패스_17" data-name="패스 17" d="M3407.974,1250.566h-.591a.4.4,0,1,1,0-.808h.591a.4.4,0,0,1,0,.808Z"
                transform="translate(-3368.301 -602.194)" fill="#1b1f2a" className="line"/>
          <path id="패스_18" data-name="패스 18" d="M3406.673,1250.557h-.357a.4.4,0,1,1,0-.808h.357a.4.4,0,0,1,0,.808Z"
                transform="translate(-3367.593 -602.188)" fill="#1b1f2a" className="line"/>
        </g>
      </svg>

    )
  }
}




